import { FaSellsy } from 'react-icons/fa';
import { TfiReceipt } from 'react-icons/tfi';
import { MdInventory2, MdOutlineLiveHelp } from 'react-icons/md';
import { RiHospitalLine } from 'react-icons/ri';
import { MdOutlinePayments } from 'react-icons/md';
import { CgCalendarToday } from 'react-icons/cg';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { CgPlayListSearch } from 'react-icons/cg';
import { GiEntryDoor } from 'react-icons/gi';
import { MdCrisisAlert } from 'react-icons/md';
import { MdCoPresent } from 'react-icons/md';
import { HiOutlineClipboardDocumentCheck } from 'react-icons/hi2';

import { RenderTiles } from '../../components/common';
import { SiKaios } from 'react-icons/si';

const adminTilesObj = [
  {
    sNo: 1,
    link: '/admin/clause1',
    isLink: true,
    clauseNo: 1,
    p: 'PRODUCTION PREPARATION /',
    span: 'NEW PRODUCT DEVELOPEMENT',
    isIcon: false,
  },
  {
    sNo: 111,
    link: '/admin/clause2',
    isLink: true,
    clauseNo: 2,
    p: 'REGULATION FOR INITIAL',
    span: 'PRODUCTION DEVELOPEMENT',
    isIcon: false,
  },
  {
    sNo: 3,
    link: '/admin/clause3',
    isLink: true,
    clauseNo: 3,
    p: 'CHANGING',
    span: 'MANAGEMENT',
    isIcon: false,
  },
  {
    sNo: 4,
    link: '/admin/clause4',
    isLink: true,
    clauseNo: 4,
    p: 'STANDARDS',
    span: 'MANAGEMENT',
    isIcon: false,
  },
  {
    sNo: 5,
    link: '/common/clause_5',
    isLink: true,
    clauseNo: 5,
    p: 'EDUCATION AND',
    span: 'TRAINING NEW',
    isIcon: false,
  },
  {
    sNo: 5,
    link: '/common/clause5',
    isLink: true,
    clauseNo: 5,
    p: 'EDUCATION AND',
    span: 'TRAINING',
    isIcon: false,
  },
  {
    sNo: 16,
    link: '/admin/clause6',
    isLink: true,
    clauseNo: 6,
    p: 'QUALITY AUDIT AND',
    span: 'PROCESS VERIFICATION',
    isIcon: false,
  },
  {
    sNo: 7,
    link: '/admin/clause7',
    isLink: true,
    clauseNo: 7,
    p: 'Supplier',
    span: 'Control',
    isIcon: false,
  },
  {
    sNo: 18,
    link: '/admin/clause8',
    isLink: true,
    clauseNo: 8,
    p: 'HANDLING ABNORMILITY',
    span: 'IN QUALITY',
    isIcon: false,
  },
  {
    sNo: 5,
    link: '/admin/clause9',
    isLink: true,
    clauseNo: 9,
    p: '5S',
    span: 'MANAGEMENT',
    isIcon: false,
  },
  {
    sNo: 9,
    link: '/admin/tagList',
    isLink: true,
    icon: <TfiReceipt size="5rem" color="#c92a2a" />,
    p: 'Generate',
    span: 'Dispatch Tag',
    isIcon: true,
  },
  {
    sNo: 9,
    link: '/admin/salesandplanning',
    isLink: true,
    icon: <FaSellsy size="5rem" color="#3bab80" />,
    p: 'Sales',
    span: '& Planning',
    isIcon: true,
  },
  {
    sNo: 9,
    link: '/admin/rmandplanning',
    isLink: true,
    icon: <MdInventory2 size="5rem" color="#343a40" />,
    p: 'RM Input',
    span: '& Planning',
    isIcon: true,
  },
  {
    sNo: 9,
    link: '/admin/salarymanagement',
    isLink: true,
    icon: <MdOutlinePayments size="5rem" color="#3bab80" />,
    p: 'Salary',
    span: 'Management',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/riDepartment',
    isLink: true,
    icon: <GiEntryDoor size="5rem" color="#a12222" />,
    p: 'RI',
    span: 'DEPARTMENT',
    isIcon: true,
  },

  // {
  //   sNo: 7,
  //   link: '/admin/clause7',
  //   isLink: true,
  //   clauseNo: 7,
  //   p: 'Supplier',
  //   span: 'Control',
  //   isIcon: false,
  // },
  {
    sNo: 10,
    link: '/admin/clause10',
    isLink: true,
    clauseNo: 10,
    p: 'EQUIPMENT / INSPECTION',
    span: "EQUIPMENT'S MANAGEMENT",
    isIcon: false,
  },
  {
    sNo: 112,
    link: '/admin/clause11',
    isLink: true,
    clauseNo: 11,
    p: 'IMPLEMENTATION OF',
    span: 'STANDARDS',
    isIcon: false,
  },
  {
    sNo: 113,
    link: '/admin/clause12',
    isLink: true,
    clauseNo: 12,
    p: 'PRODUCTS',
    span: 'MANAGEMENT',
    isIcon: false,
  },
  {
    sNo: 114,
    link: '/admin/clause13',
    isLink: true,
    clauseNo: 13,
    p: 'HANDLING',
    span: 'MANAGEMENT',
    isIcon: false,
  },
  {
    sNo: 115,
    link: '/admin/clause14',
    isLink: true,
    clauseNo: 14,
    p: 'CRITICAL PARTS',
    span: 'MANAGEMENT',
    isIcon: false,
  },
  {
    sNo: 15,
    link: '/admin/clause15',
    isLink: true,
    clauseNo: 15,
    p: 'ADEQUATE TESTING',
    span: 'FACILITY',
    isIcon: false,
  },
  {
    sNo: 116,
    link: '/admin/clause16',
    isLink: true,
    clauseNo: 16,
    p: 'PROCESS',
    span: 'AUDIT',
    isIcon: false,
  },
  {
    sNo: 117,
    link: '/admin/clause17',
    isLink: true,
    clauseNo: 17,
    p: 'SCALE AND TOP',
    span: 'MANAGEMENT BANDWIDTH',
    isIcon: false,
  },
  {
    sNo: 118,
    link: '/admin/clause18',
    isLink: true,
    clauseNo: 18,
    p: 'SAFETY',
    span: '',
    isIcon: false,
  },
  {
    sNo: 119,
    link: '/admin/clause19',
    isLink: true,
    clauseNo: 19,
    p: 'LEGAL COMPLIANCE',
    span: 'AND ENVIRONMENT',
    isIcon: false,
  },
  {
    sNo: 2,
    link: '/common/production',
    isLink: true,
    icon: <CgCalendarToday size="5rem" color="#212529" />,
    p: 'PRODUCTION',
    span: 'MANAGEMENT',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/scrapNoteList',
    isLink: true,
    icon: <RiDeleteBin4Fill size="5rem" color="#a12222" />,
    p: 'SCRAP NOTE',
    span: 'REPORT',
    isIcon: true,
  },
  {
    sNo: 8,
    link: '/common/machineCheckSheet',
    isLink: true,
    icon: <CgPlayListSearch size="5rem" color="#003566" />,
    p: 'MACHINE',
    span: 'CHECK SHEET',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/redBinMonitoringSheet',
    isLink: true,
    icon: <CgCalendarToday size="5rem" color="#212529" />,
    p: 'RED BIN MONITORING',
    span: 'SHEET',
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/qualityChecksheets',
    isLink: true,
    icon: <HiOutlineClipboardDocumentCheck size="5rem" color="#a12222" />,
    p: 'Quality',
    span: 'CHECKSHEETS',
    isIcon: true,
  },
  {
    sNo: 40,
    link: `/common/kaizenSubmissionList`,
    isLink: true,
    icon: <SiKaios size="5rem" color="#003566" />,
    p: 'KAIZEN',
    span: 'SUBMISSION',
    isIcon: true,
  },
  {
    sNo: 9,
    link: `/common/mushinHelpDesk`,
    isLink: true,
    icon: <MdOutlineLiveHelp size="5rem" color="#003566" />,
    p: 'MUSHIN HELP',
    span: 'DESK',
    isIcon: true,
  },
];

const AdminHome = () => {
  return (
    <RenderTiles
      tilesObj={adminTilesObj}
      // height="100vh"
      // justify="start"
      // columns="0fr"
    />
  );
};

export default AdminHome;
